export function mixParent(key) {
  return {
    provide() {
      return {
        [key]: this
      }
    },
    data() {
      return {
        children: []
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/utils/mix-parent.js